<template>
  <div>
    <loader v-if="loading"
      :label="$t('conflict.searchingTodos')"
    />
    <v-container v-else
    >
      <v-row
        class="white"
        dense
      >
        <v-col
          class="py-0"
        >
        <h3 class="ml-3">{{ $t('conflict.inThisScenario') }}</h3>
        <div class="px-4 py-2">
          <scenario
          :scenario="todo.preference.scenario"
          :show-details="debugMode"
          />
        </div>
        </v-col>
      </v-row>
      <v-row
        class="my-2 white"
        dense
      >
        <v-col
          class="px-4 py-2"
        >
          <h3 class="mb-3">{{ $t('option.favorite') }}</h3>
          <wigo-chip
            :wigo="todo.preference.wigo"
            :show-details="debugMode"
          />
        </v-col>
      </v-row>
      <v-row
        class="raison-highlight mt-4"
        dense
      >
        <v-col
          class="py-0"
        >
          <div class="px-4 py-2">
            <h3 class="pb-3">
              {{ $t('conflict.canYouAddElementToPrefer') }}
            </h3>
            <wigo-chip
              :wigo="todo.preference.logo"
              :show-details="debugMode"
            />
          </div>
        </v-col>
      </v-row>
      <v-row
        class="raison-highlight"
        dense
      >
        <v-col
          class="py-0"
        >
          <div
            v-if="editing"
            class="px-4 py-2"
          >
            <h3>{{ $t('conflict.whichOnes') }}</h3>
            <input-scenario
              class="my-2"
              :available-elements="filteredElements"
              :elements.sync="elementsAdded"
              v-on="$listeners"
            />
            <div class="text-center">
              <v-btn
                class="raison-btn"
                :disabled="loading || !valid"
                @click="challenge(elementsAdded)"
              >
              {{ $t('editor.scenario.save') }}
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-if="!editing"
        class="raison-highlight"
        dense
      >
        <v-col
          align="center"
        >
          <v-btn
            class="raison-btn"
            @click="yes"
          >
            {{ $t('global.yes') }}
          </v-btn>
          <v-btn
            class="raison-btn"
            @click="no"
          >
            {{ $t('global.no') }}
          </v-btn>
          <v-btn
            v-if="shouldDiscriminatePreferredOptions"
            class="raison-btn"
            @click="noButIWantToDiscriminateBetweenThePreferredOptions"
            :disabled="todo.preference.wigo.length <= 1"
          >
            {{ $t('conflict.noButIWantToDiscriminateBetweenThePreferredOptions') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <created-preferences
            v-if="hasContextualPreferences"
            :preferences="todo.contextualPreferences"
            :current-elements="todo.preference.scenario.elements"
            :show-details="debugMode"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import CreatedPreferences from '@/components/conflictResolution/CreatedPreferences'
import InputScenario from '@/components/editor/InputScenario'
import Loader from '@/components/global/Loader'
import Scenario from '@/components/global/Scenario'
import WigoChip from '@/components/global/WigoChip'

import debugModeMixin from '@/mixins/debug-mode-mixin.js'

import conflictService from '@/services/conflicts.js'
import elementService from '@/services/elements.js'
import helpService from '@/services/help.js'

export default ({
  name: 'ChallengePreference',

  components: {
    CreatedPreferences,
    Loader,
    InputScenario,
    Scenario,
    WigoChip
  },

  mixins: [ debugModeMixin ],

  data () {
    return {
      loading: false,
      editing: false,
      valid: true,
      elements: [],
      elementsAdded: []
    }
  },

  props: {
    todo: {
      type: Object,
      required: true
    }
  },

  computed: {
    shouldDiscriminatePreferredOptions() {
      return this.todo
        && ( this.todo.preference.wigo.length > 1 || this.todo.preference.logo.length > 1 )
    },
    hasContextualPreferences() {
      return this.todo && this.todo.contextualPreferences.length > 0
    },
    filteredElements() {
      return elementService.filterElements(this.elements, this.todo.preference.scenario.elements)
    }
  },

  methods: {
    yes() {
      // console.log('yes')
      this.editing = true
      if(this.todo && this.todo.contextualPreferences.length > 0) {
        helpService.setHelpPage(this.$store, 'challenge_preference_editing_with_alternatives')
      }
      else {
        helpService.setHelpPage(this.$store, 'challenge_preference_editing')
      }

    },
    no() {
      // console.log('no')
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      conflictService.prefer(projectId, conflictId, {
        resolution: "Solved",
        scenario: this.todo.preference.scenario.id,
        todoId: this.todo.id
      })
      .then(response => {
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] })
      })
      .finally(() => {
        this.loading = false
      });
    },
    challenge(elementsAdded) {
      // console.log('challenge', this.todo.preference, elementsAdded)
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      conflictService.prefer(projectId, conflictId, {
        resolution: "ChallengePreference",
        wigo: this.todo.preference.logo.map(option => option.id),
        preference: this.todo.preference.id,
        byAddingInformation: elementsAdded.map(element => element.id)
      })
      .then(response => {
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] })
      })
      .finally(() => {
        this.elementsAdded = []
        this.editing = false
        this.loading = false
      });
    },
    noButIWantToDiscriminateBetweenThePreferredOptions() {
      // console.log('noButIWantToDiscriminateBetweenThePreferredOptions', this.conflict)
      this.loading = true
      const projectId = this.$route.params.id
      const conflictId = this.$route.params.conflict
      conflictService.prefer(projectId, conflictId, {
        resolution: "DiscriminatePreferredOptions",
        todoId: this.todo.id
      })
      .then(response => {
        const todo = response.data
        this.$emit('nextTodo', todo)
      })
      .catch(err => {
        this.$emit('raison-event', { type:'error', messages:[err] });
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },

  created () {
    console.log('challengePreference.created: todo', this.todo)
    this.loading = true
    elementService.getElements(this.$route.params.id)
      .then(res => {
        this.elements = res.data
      })
      .catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] })
      })
      .finally(() => {
        this.loading = false;
      });
  }
})
</script>
<style>
</style>